import { render } from "./QueueManagement.vue?vue&type=template&id=28271b49&scoped=true"
import script from "./QueueManagement.vue?vue&type=script&lang=js"
export * from "./QueueManagement.vue?vue&type=script&lang=js"

import "./QueueManagement.vue?vue&type=style&index=0&id=28271b49&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28271b49"]])

export default __exports__